<template>
    <div class="module">
      <template v-if="showKey=='module'">
        <!-- <div class="module-header">
          <a-icon type="arrow-left" class="module-back"  @click="back()"/>
          {{ diseaseName }}
        </div> -->
        <a-checkbox-group v-model="moduleChecked" class="checkbox" >
          <div class="title">
            <strong>通用模块</strong>
            <!-- <span>已选 {{ moduleChecked.length }} 个</span> -->
          </div>
          <div class="module-panel" >
            <a-row :gutter="[10,10]" v-if="module1List.length>0" >
              <a-col :span="6" v-for="item in module1List" :key="item.code">
                <a-checkbox :value="item.code" class="checkbox-item">
                  <div>
                    <a-icon type="question-circle" class="checkbox-item-icon" />
                  </div>
                  <div class="checkbox-item-name">
                    {{ item.name }}
                  </div>
                </a-checkbox>
              </a-col>
            </a-row>
            <div v-else>
              <a-empty>
                <span slot="description" style="color: white;">暂无数据</span>
              </a-empty>
            </div>
          </div>
          <br>
          <div class="title">
            <strong>专科模块</strong>
            <!-- <span>已选 {{ moduleChecked.length }} 个</span> -->
          </div>
          <div class="module-panel">
            <a-row :gutter="[10,10]" v-if="module2List.length>0">
              <a-col :span="6" v-for="item in module2List" :key="item.code "  >
                <a-checkbox :value="item.code" class="checkbox-item">
                  <div>
                    <a-icon type="question-circle" class="checkbox-item-icon" />
                  </div>
                  <div class="checkbox-item-name">
                    {{ item.name }}
                  </div>
                </a-checkbox>
              </a-col>
            </a-row>
            <div v-else>
              <a-empty>
                <span slot="description" style="color: white;"> 暂无数据</span>
              </a-empty>
            </div>
          </div>
        </a-checkbox-group>
        <div class="btn-panel">
          <a-button type="primary" class="btn" @click="configForm">配置量表</a-button>
        </div>
      </template>
      <module-form v-if="showKey=='form'" :data="moduleFormData" :diseaseCode="diseaseCode" :project="project" @backHandle="backHandle" @save="moduleFormSave"></module-form>
    </div>
</template>

<script>
import { getAction, postAction } from '@api/manage'
import ModuleForm from '@views/apppad/projectTemplate/projectTemplate2/ModuleForm.vue'

  export default {
    name: 'Module',
    components: { ModuleForm },
    props:{
      diseaseCode:{
        type:String,
        default:''
      },
      diseaseName:{
        type:String,
        default:''
      },
      project:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    },
    data(){
      return {
        moduleChecked:[],
        dataSource:[],
        showKey:'module',
        moduleFormData:[],
      }
    },
    watch:{
      project(){
        this.initModuleChecked()
      },
      diseaseCode(){
        this.loadData()
        this.initModuleChecked()
      }
    },
    computed:{
      module1List(){
        const result = []
        this.dataSource.forEach(item=>{
          if('1' == item.type){
            result.push(item)
          }
        })
        return result
      },
      module2List(){
        const result = []
        this.dataSource.forEach(item=>{
          if('2' == item.type){
            result.push(item)
          }
        })
        return result
      },
      diseaseModuleList(){
        if(this.project.moduleJson){
          const moduleJson = JSON.parse(this.project.moduleJson)
          return  moduleJson[this.diseaseCode] || []
        }
        return []
      }
    },
    mounted(){
      this.loadData()
      this.initModuleChecked()
    },
    methods:{
      initModuleChecked(){
        const moduleChecked = []
        this.diseaseModuleList.forEach(item=>{
          moduleChecked.push(item.code)
        })
        this.moduleChecked = moduleChecked
      },
      initDataSource(dataSource){
        // json格式[{name:'',code:'',type:'',formList:[]}]
        const diseaseModule = this.diseaseModuleList
        dataSource.forEach(item=>{
          item.formList = []
          for (let i = 0; i < diseaseModule.length; i++) {
            const module = diseaseModule[i]
            if(module.code == item.code){
              item.formList = item.formList || []
              break
            }
          }
        })
        this.dataSource = dataSource
      },
      loadData(){
        if(this.diseaseCode){
          getAction('/projectconfigview/configModule/list', { diseaseCode:this.diseaseCode }).then(res=>{
            if(res.success){
              this.initDataSource(res.result)
            }
          })
        }
      },
      back(){
        this.$emit('backHandle')
      },
      configForm(){
        const moduleFormData = []
        let diseaseModuleList = this.diseaseModuleList
        this.dataSource.forEach(item=>{
          if(this.moduleChecked.indexOf(item.code)>=0){
            const module = JSON.parse(JSON.stringify(item))
            module.checkedFormList =  []
            for (let i = 0; i < diseaseModuleList.length; i++) {
              const jsonItem = diseaseModuleList[i]
              if(jsonItem.code==module.code){
                module.checkedFormList = jsonItem.checkedFormList || []
                break
              }
            }
            moduleFormData.push(module)
          }
        })
        if(moduleFormData.length==0){
          return this.$message.warn('请选择至少一个模块')
        }
        this.moduleFormData = moduleFormData
        this.showKey = 'form'
      },
      backHandle(){
        this.showKey ='module'
      },
      moduleFormSave(moduleFormData){
        let moduleJson = {}
        if(this.project.moduleJson){
          moduleJson = JSON.parse(this.project.moduleJson)
        }
        moduleJson[this.diseaseCode] = moduleFormData
        postAction('/projectconfigview/configProject/saveModule',{id:this.project.id,moduleJson:JSON.stringify(moduleJson)}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.backHandle()
            this.$emit('submit')
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .module{
    .module-header{
      font-size: 24px;
      color: white;
      font-weight: bold;
      text-align: center;
      position: relative;
    }
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      strong{
        color: #FFFFFF;
        font-weight: 600;
        font-size: 18px;
      }
      span{
        font-weight: 400;
        font-size: 11px;
        color: rgba(255,255,255,0.7);
      }
    }
    .checkbox{
      display: block;
      width: 100%;
    }
    .module-panel{
      overflow: hidden;
      width: 100%;
      margin-top: 15px;
      .checkbox-item{
        position: relative;
        // margin: 10px;
        // width: calc(100% - 20px);
        width: 100%;
        // border: 1px solid rgba(0,0,0,0.2);
        border-radius: 12px;
        padding: 0 10px;
        background: rgba(255,255,255,0.15);
        .checkbox-item-icon{
          font-size: 20px;
          color: white;
        }
        .checkbox-item-name{
          color:white;
        }
        /deep/ .ant-checkbox{
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }

        /deep/ .ant-checkbox-checked .ant-checkbox-inner{
          background-color: #1890ff;
          border-color: #1890ff;
        }
        /deep/ .ant-checkbox + span{
          display: block;
          padding: 18px 0;
        }
      }
      // .checkbox-item span:last-child{
      //   background-color: red;
      // }
    }
    .btn-panel{
      width: 95%;
      position: absolute;
      bottom: 20px;
      .btn{
        width: 100%;
        font-size: 14px;
        border: none;
        border-radius: 20px;
        background: linear-gradient( 90deg, #376EFF 0%, #DE5DFE 100%);
      }
    }
  }
</style>